<template>
    <div>
        <b-modal id="import-modal" title="Import tác vụ" size="lg" hide-footer centered>
            <div v-if="!displayErrorCheckTable">
                <p>Bước 1: Sử dụng link Google Sheet bên dưới</p>
                <a href="https://docs.google.com/spreadsheets/d/1l50nm4HsDNnM7CjRQLiyNOJgMZxvFRs_B4IrwfB5aCU/edit?gid=0#gid=0"
                    style="text-decoration-line: underline;" target="_blank">Link
                    Google Sheet</a>
                <p class="mt-4">Bước 2: Thiết lập dữ liệu tại file Google Sheet, tải xuống file định dạng .csv và upload
                    file đó lên
                    hệ
                    thống</p>
                <button @click="openPicker()" type="button" class="btn btn-warning" :disabled="nameFile !== ''"><i
                        class="flaticon-upload mr-2"></i>Upload file
                </button>
                <input ref="picker" type="file" accept=".csv,text/csv" style="display:none" @change="onPick" />
                <div class="mt-6" style="width: fit-content; position: relative" v-if="nameFile">
                    <span style="background-color: #D9D9D9; border-radius: 4px " class="px-2 py-2">{{ nameFile }}</span>
                    <i @click="deleteFile()" class="text-danger el-icon-circle-close cursor-pointer ml-4"
                        style="position: absolute;right: -8px; top:-15px"></i>
                </div>
            </div>
            <div v-else class="preview-section">
                <PreviewTable :data="dataJson" :rules="TutorTaskSchema" :labels="labels" @validated="handleValidated"
                    :external-errors="extendError" />
            </div>
            <div class="mt-6 d-flex justify-content-end">
                <button type="button" class="btn btn-secondary mr-4" :disabled="loading"
                    @click="closeModal()">Hủy</button>
                <button v-if="isValid === null" type="button" class="btn btn-primary" @click="checkError()"
                    :disabled="loading || nameFile === ''"><i class="el-icon-loading" v-if="loading"></i>Tiếp
                    theo</button>
                <button v-else-if="isValid === true" type="button" class="btn btn-primary" @click="importTutorTask()"
                    :disabled="loading"><i class="el-icon-loading" v-if="loading"></i>Import</button>
                <button v-else type="button" class="btn btn-danger" @click="backImportDisplay()">Quay lại</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { removeVietnameseTones } from '../../../../../core/filters';
import { TutorTaskSchema } from '../../../../../core/schemas/tutorTask.validation.schema';
import PreviewTable from "@/components/PreviewTable.vue";
import { IMPORT_TUTOR_TASK_DATA, VALIDATE_TUTOR_TASK_DATA } from '../../../../../core/services/store/tutor/tutor.module';
export default {
    name: "TutorTaskImportModal",
    components: {
        PreviewTable
    },
    data() {
        return {
            dataJson: [],
            nameFile: "",
            displayErrorCheckTable: false,
            ErrorCheckTableData: [],
            isValid: null,
            loading: false,
            extendError: [],
            labels: {
                tac_vu: 'Tác vụ',
                phan_loai: 'Phân loại',
                doi_tuong_xu_ly: 'Đối tượng xử lý',
                ngay_lam: 'Ngày làm',
                thoi_gian_lam: 'Thời gian làm',
                ma_nhan_su_admin: 'Mã nhân sự Admin',
                ma_lop: 'Mã lớp',
                noi_dung_gia_su: 'Nội dung gia sư',
                link_zalo_lop_dem: 'Link Zalo lớp đệm',
                trinh_do_lop_hoc_bo_tro: 'Trình độ lớp học bổ trợ',
                nang_luc_gia_su: 'Năng lực gia sư',
                so_luong_hoc_vien: 'Số lượng học viên',
                link_zalo_lop_ho_tro: 'Link Zalo lớp hỗ trợ',
            }
        }
    },
    computed: {
        TutorTaskSchema() {
            return TutorTaskSchema
        }
    },
    methods: {
       async importTutorTask() {
            try {
                this.loading = true
                const res = await this.$store.dispatch(IMPORT_TUTOR_TASK_DATA, this.dataJson)
                this.$message({
                    showClose: true,
                    message: 'Import thành công',
                    type: 'success'
                });
                this.$bvModal.hide('import-modal')
                this.$emit('createSuccess')
            } catch (e) {
                this.$message({
                    showClose: true,
                    message: `${e?.response.data?.message}`,
                    type: 'error'
                });
            } finally {
                this.loading = false
            }
        },
        openPicker() {
            this.$refs.picker && this.$refs.picker.click();
        },
        async onPick(event) {
            if (event.target.files[0].type !== 'text/csv') {
                this.$notify({
                    title: 'Sai định dạng',
                    message: 'File import phải là file csv',
                    type: 'warning'
                });
                event.target.value = ''
                return
            }

            if (!event.target.files.length) {
                event.target.files = null
                return
            }
            let dataImport = event.target.files[0];

            try {
                this.dataJson = await this.fileToJson(dataImport)
                this.dataJson.forEach((data) => {
                    Object.keys(data).forEach((key) => {
                        data[this.convertKey(key)] = data[key]
                        delete data[key];
                    })
                    this.normalizeSupplementaryTutorFields(data)
                })
                this.nameFile = event.target.files[0].name
            } catch (error) {
                console.error('Error processing file:', error);
                this.$notify({
                    title: 'Lỗi',
                    message: 'Có lỗi xảy ra khi đọc file: ' + error.message,
                    type: 'error'
                });
            } finally {
                event.target.value = ''
            }
        },
        convertKey(key) {
            let myString = removeVietnameseTones(key);
            let trimmedString = myString.trim();
            let formattedString = trimmedString.replace(/\s+/g, '_');
            return formattedString.toLowerCase()
        },
        normalizeSupplementaryTutorFields(data) {
            if (data.link_zalo_bo_tro !== undefined) {
                data.link_zalo_lop_ho_tro = data.link_zalo_bo_tro
                delete data.link_zalo_bo_tro
            }
        },
        async fileToJson(file) {
            return new Promise((res, rej) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        const rawText = (e.target.result || '').toString();
                        // Bỏ BOM nếu có
                        const csvText = rawText.replace(/^\uFEFF/, '');

                        // Parse toàn bộ text (KHÔNG split theo \n trước)
                        const rows = this.parseCSV(csvText);
                        if (!rows.length) {
                            rej(new Error('File CSV rỗng'));
                            return;
                        }

                        // Hàng 1 là header
                        const headers = rows[0].map(h => (h || '').replace(/^\uFEFF/, '').trim());

                        // Các hàng sau là dữ liệu
                        const processed = rows.slice(1)
                            .filter(r => r.some(cell => (cell || '').trim() !== '')) // bỏ dòng trống thật sự
                            .map(row => {
                                const obj = {};
                                headers.forEach((h, i) => {
                                    obj[h] = (row[i] ?? '').toString();
                                });
                                return obj;
                            });

                        res(processed);
                    } catch (err) {
                        rej(err);
                    }
                };
                reader.onerror = (e) => rej(e);
                reader.readAsText(file, 'utf-8');
            });
        },
        parseCSV(text) {
            const rows = [];
            let row = [];
            let field = '';

            let inQuotes = false;
            const len = text.length;

            for (let i = 0; i < len; i++) {
                const c = text[i];

                if (c === '"') {
                    if (inQuotes) {
                        // Nếu đang trong quotes và gặp "" -> nghĩa là ký tự " literal
                        if (i + 1 < len && text[i + 1] === '"') {
                            field += '"';
                            i++; // bỏ qua ký tự " tiếp theo
                        } else {
                            // đóng quotes
                            inQuotes = false;
                        }
                    } else {
                        // mở quotes (chỉ mở nếu field hiện tại chưa có gì hoặc vừa gặp delimiter)
                        inQuotes = true;
                    }
                    continue;
                }

                if (!inQuotes) {
                    if (c === ',') {
                        // kết thúc 1 field
                        row.push(field);
                        field = '';
                        continue;
                    }

                    if (c === '\n' || c === '\r') {
                        // kết thúc 1 row
                        row.push(field);
                        field = '';
                        // xử lý CRLF: nếu là \r\n thì nhảy qua \n
                        if (c === '\r' && i + 1 < len && text[i + 1] === '\n') i++;
                        rows.push(row);
                        row = [];
                        continue;
                    }
                }

                // ký tự bình thường
                field += c;
            }

            // đẩy nốt field/row cuối nếu còn
            row.push(field);
            // nếu dòng cuối không hoàn toàn trống thì thêm vào
            if (row.length > 1 || (row.length === 1 && row[0] !== '')) {
                rows.push(row);
            }
            return rows;
        },
        deleteFile() {
            this.nameFile = "";
            this.dataJson = []
        },
        closeModal() {
            this.$bvModal.hide('import-modal')
        },
        async checkError() {
            try {
                this.loading = true
                let res = await this.$store.dispatch(VALIDATE_TUTOR_TASK_DATA, this.dataJson)
                this.extendError = res?.data?.errors ?? []
                this.displayErrorCheckTable = true;
            } catch (e) {
                this.displayErrorCheckTable = true;
            } finally {
                this.loading = false
            }

        },
        backImportDisplay() {
            this.displayErrorCheckTable = false;
            this.isValid = null
        },
        handleValidated({ errors, isValid }) {
            this.validationErrors = errors || []
            this.isValid = isValid;
        },
        resetData() {
            this.dataJson = [];
            this.nameFile = "";
            this.displayErrorCheckTable = false;
            this.ErrorCheckTableData = [];
            this.isValid = null;
            this.validationErrors = []
        }
    }
}
</script>
